import { Button } from "antd";
import { useDesactivarCodigoPokemon } from "../../../../Hooks/Admin";
import { useQueryClient } from "react-query";
import { useSelectLogro } from "../../../../Hooks/Admin";


const DesactivarButton = ({ idCodigo, estado }) => {
  const apiDesactivar = useDesactivarCodigoPokemon();
  const queryClient = useQueryClient();
  return (
    <Button
      type="primary"
      danger
      disabled={estado === "Desactivado"}
      onClick={async () => {
        try {
          const response = await apiDesactivar.mutateAsync({ idCodigo });

          if (response?.success) {
            //alert("Código desactivado correctamente");
            queryClient.invalidateQueries("listarCuponesPokemones");
            window.location.reload();
          } else {
            throw new Error(response?.message || "Error desconocido");
          }
        } catch (error) {
          console.error("Error:", error);
          alert("Hubo un problema al desactivar el código");
        }
      }}
    >
      Desactivar Código
    </Button>
  );
};

export const columns = [
  {
    title: "Codigo",
    dataIndex: "codigo",
    width: "20%",
  },
  {
    title: "Nombre",
    dataIndex: "titulo",
    width: "20%",
  },
  {
    title: "Fecha Creación",
    dataIndex: "fechaCreacion",
    width: "20%",
  },
 
  {
    title: "Tier",
    dataIndex: "tier",
    width: "20%",
  },

  

];
export const formatData = (data) => {
  return {
    idGachapon: data.idGachapon,
    titulo: data.titulo,
    imagen: data.imagen,
    codigo: data.codigo,
    tier:data.tier,
    probComun: data.probComun,
    probRaro: data.probRaro,
    probEpico: data.probEpico,
    probLegendario: data.probLegendario,
  };
};

export const camposFormulario = ({pokemones, logros}) => {
 
  return {
    title: "Gachaponess",
    campos: [
      {
        name: "codigo",
        label: "Codigo",
        type: "text",
        rules: [
          {
            required: true,
            message: "El código es obligatorio",
          },
        ],
      },
      {
        name: "titulo",
        label: "Titulo",
        type: "text",
        rules: [
          {
            required: true,
            message: "El título es obligatorio",
          },
        ],
      },
      {
        name: "imagen",
        label: "Imagen",
        type: "text",
        rules: [
          {
            required: true,
            message: "La URL de la imagen es obligatoria",
          },
        ],
      },
       {
        name: "logro",
        label: "Logro asociado",
        type: "select",
        opciones: logros ?? [],
        rules: [
          {
            required: true,
            message: "Debe seleccionar un logro asociado",
          },
        ],
      },
      {
        name: "tier",
        label: "Tier",
        type: "number",
        max: 4,
        min: 1,
        rules: [
          {
            required: true,
            message: "El tier es obligatorio",
          },
        ],
      },
      {
        name: "probComun",
        label: "Probabilidad Comun",
        type: "number",
        max: 1000,
        min: 1,
        rules: [
          {
            required: true,
            message: "La probabilidad común es obligatoria",
          },
        ],
      },
      {
        name: "probRaro",
        label: "Probabilidad Raro",
        type: "number",
        max: 1000,
        min: 1,
        rules: [
          {
            required: true,
            message: "La probabilidad raro es obligatoria",
          },
        ],
      },
      {
        name: "probEpico",
        label: "Probabilidad Epico",
        type: "number",
        max: 1000,
        min: 1,
        rules: [
          {
            required: true,
            message: "La probabilidad épico es obligatoria",
          },
        ],
      },
      {
        name: "probLegendario",
        label: "Probabilidad Legendario",
        type: "number",
        max: 1000,
        min: 1,
        rules: [
          {
            required: true,
            message: "La probabilidad legendario es obligatoria",
          },
        ],
      },
     
    ],
    extra: (
      <div style={{ color: 'orange', marginBottom: 16 }}>
        La suma de las probabilidades de común, raro, épico y legendario debe ser <b>1000</b>.
      </div>
    ),
  };
};

export const camposFilter = {
  title: "Codigos Objetos",
  campos: [
    {
      name: "codigo",
      type: "text",
      label: "Codígo",
    },
  ],
};
